export default {
  EVENT_USER: 'EVENT_USER',
  EVENT_TOKE: 'Authorization',
  EVENT_PHONE: 'EVENT_PHONE',
  SUCCESS: 10000,
};
